import { FC, ReactNode, useMemo } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Message from './Message'
import { capitalize } from '../utils/string'

type ErrorWrapperProps = {
  errors: string[]
  children?: ReactNode
  timeout?: number
}

const ErrorWrapper: FC<ErrorWrapperProps> = ({ errors = [], children, timeout = 600 }) => {
  const errorMessages = useMemo(() => {
    if (errors.length === 0) return null

    const messages = errors.map((error, index) => (
      <li className="messages-list__list-item" key={`list-item-${index}`}>
        <Message type="error">{capitalize(error)}</Message>
      </li>
    ))

    return (
      <CSSTransition classNames="fade-in-out" timeout={timeout}>
        <ul className="unstyled-list messages-list" role="alert" aria-live="polite">
          {messages}
        </ul>
      </CSSTransition>
    )
  }, [errors, timeout])

  return (
    <>
      {children}
      <TransitionGroup>{errorMessages}</TransitionGroup>
    </>
  )
}

export default ErrorWrapper
